import ReactDateRangePicker from 'components/ReactDateRangePicker/ReactDateRangePicker';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import AddSingleMemberDropdown from '../../../components/CustomDropdown/AddSingleMemberDropdown';
import CreateProjectDropdown from '../../../components/DropdownStyle/CreateProjectDropdown';
import Select from '../../../components/ReactSelectDropdown';
import { filterOption } from '../../../components/ReactSelectDropdown/ReactSelectDropdown';
import {
  FilterLabel,
  InputWithLabelSection,
} from '../../../styledComponents/common';
import { FilterContainer } from '../../../styledComponents/tasks';

const ItemsCountingReportFilter = ({
  getItemsCountingReport,
  getItemsList,
  itemsList,
  getPublicZoneList,
  publicZoneList,
  getOfficesShortList,
  officesShortList,
  getOrganizationMembersList,
  orgMembersList,
  setSelectedParams,
  selectedParams,
}) => {
  const { t } = useTranslation();
  const [selectedDate, setSelectedDate] = useState({
    startDate: moment().subtract(7, 'days'),
    endDate: moment(),
  });
  const [item, setItem] = useState({
    label: t('all_items'),
    value: null,
  });
  const [itemOptions, setItemOptions] = useState([
    {
      label: t('all_items'),
      value: null,
    },
  ]);
  const [selectedPublicZone, setSelectedPublicZone] = useState({
    label: t('all_public_zones'),
    value: null,
  });
  const [selectedOffice, setSelectedOffice] = useState({
    label: t('all_offices'),
    value: null,
  });
  const [publicZoneOptions, setPublicZoneOptions] = useState([
    {
      label: t('all_public_zones'),
      value: null,
    },
  ]);
  const [officeOptions, setOfficeOptions] = useState([
    {
      label: t('all_offices'),
      value: null,
    },
  ]);
  const [memberOptions, setMemberOptions] = useState([]);
  const [selectedAssignee, setSelectedAssignee] = useState(null);

  useEffect(() => {
    getPublicZoneList && getPublicZoneList();
    getItemsList && getItemsList();
    getOrganizationMembersList();
  }, []);

  useEffect(() => {
    if (selectedPublicZone?.value) {
      getOfficesShortList({ public_zone_id: selectedPublicZone.value });
    } else getOfficesShortList();
  }, [selectedPublicZone]);

  useEffect(() => {
    if (selectedOffice?.value) {
      getOrganizationMembersList({ office_id: selectedOffice.value });
    }
  }, [selectedOffice]);

  useEffect(() => {
    if (publicZoneList && publicZoneList.length > 0) {
      let newArr = [
        {
          label: t('all_public_zones'),
          value: null,
        },
      ];
      publicZoneList.forEach(zone => {
        newArr.push({
          label: zone.name,
          value: zone.id,
        });
      });
      setPublicZoneOptions(newArr);
    }
  }, [publicZoneList]);

  useEffect(() => {
    if (officesShortList && officesShortList.length > 0) {
      let newArr = [
        {
          label: t('all_offices'),
          value: null,
        },
      ];
      officesShortList.forEach(office => {
        newArr.push({
          label: office.name,
          value: office.id,
        });
      });
      setOfficeOptions(newArr);
    }
  }, [officesShortList]);

  useEffect(() => {
    setMemberOptions(orgMembersList);
  }, [orgMembersList]);

  useEffect(() => {
    if (itemsList && itemsList.length > 0) {
      let newArr = [
        {
          label: t('all_items'),
          value: null,
        },
      ];
      itemsList.forEach(item => {
        newArr.push({
          label: item.name,
          value: item.id,
        });
      });
      setItemOptions(newArr);
    }
  }, [itemsList]);

  useEffect(() => {
    callGetItemsCountingReport();
  }, [
    selectedDate,
    item,
    selectedPublicZone,
    selectedOffice,
    selectedAssignee,
  ]);

  const callGetItemsCountingReport = () => {
    const payload = {};
    selectedDate.startDate &&
      (payload.start = selectedDate.startDate.format('YYYY-MM-DD'));
    selectedDate.endDate &&
      (payload.end = selectedDate.endDate.format('YYYY-MM-DD'));
    item?.value && (payload.item_id = item.value);
    selectedPublicZone?.value &&
      (payload.public_zone_id = selectedPublicZone.value);
    selectedOffice?.value && (payload.office_id = selectedOffice.value);
    selectedAssignee?.id && (payload.assignees = selectedAssignee.id);

    // Update the selectedParams for export functionality
    setSelectedParams && setSelectedParams(payload);

    getItemsCountingReport(payload);
  };

  const handleDateChange = date => {
    setSelectedDate(date);
  };

  const handleItemChange = e => {
    setItem(e);
  };

  const handlePublicZoneChange = e => {
    setSelectedPublicZone(e);
  };

  const handleOfficeChange = e => {
    setSelectedOffice(e);
  };

  const handleAssigneeSelect = person => {
    setSelectedAssignee(person);
  };

  const handleClearAssignee = () => {
    setSelectedAssignee(null);
  };

  return (
    <FilterContainer marginTop="30px">
      <InputWithLabelSection width="200px">
        <FilterLabel>{t('public_zone')}</FilterLabel>
        <Select
          isSearchable={false}
          value={selectedPublicZone}
          options={publicZoneOptions}
          placeholder={t('select_public_zone')}
          onChange={handlePublicZoneChange}
          styles={CreateProjectDropdown()}
          filterOption={filterOption}
        />
      </InputWithLabelSection>
      <InputWithLabelSection width="200px">
        <FilterLabel>{t('office')}</FilterLabel>
        <Select
          isSearchable={false}
          value={selectedOffice}
          options={officeOptions}
          placeholder={t('select_office')}
          onChange={handleOfficeChange}
          styles={CreateProjectDropdown()}
          filterOption={filterOption}
        />
      </InputWithLabelSection>
      <InputWithLabelSection>
        <FilterLabel>{t('assignee')}</FilterLabel>
        <div style={{ width: `40px` }}>
          <AddSingleMemberDropdown
            assigneeManage={selectedAssignee}
            updateState={handleAssigneeSelect}
            membersList={memberOptions}
            clearAssignee={handleClearAssignee}
          />
        </div>
      </InputWithLabelSection>
      <InputWithLabelSection width="200px">
        <FilterLabel>{t('item')}</FilterLabel>
        <Select
          isSearchable={false}
          value={item}
          options={itemOptions}
          placeholder={t('select_item')}
          onChange={handleItemChange}
          filterOption={filterOption}
          styles={CreateProjectDropdown()}
        />
      </InputWithLabelSection>
      <InputWithLabelSection width="max-content">
        <FilterLabel>{t('date_range')}</FilterLabel>
        <ReactDateRangePicker
          startDate={selectedDate.startDate}
          startDateId="items-counting-start-date"
          endDate={selectedDate.endDate}
          endDateId="items-counting-end-date"
          onDatesChange={handleDateChange}
          dateDisplayFormat="DD/MM/YYYY"
        />
      </InputWithLabelSection>
    </FilterContainer>
  );
};

export default ItemsCountingReportFilter;
